import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

const
    filterParamsMap = {
        account: 'account_id'
    },
    name = 'severities',
    exports = storeModuleFactory({
        name,
        filterParamsMap,
        timeout:  TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        endpoint: endpoints.severities.endpoint
    });

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/severities.js